import { apiClient } from "@/common/api/Service";
import { snakeToCamelCase } from "@/common/common";
import { collectionToCurrency } from "@/common/api/Services/Data/Currency/Transformer";
async function getCurrencies() {
    const client = apiClient();
    return client.get("/appv2/data/currencies")
        .then((res) => collectionToCurrency(snakeToCamelCase(res)));
}
export { getCurrencies };
